import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FleetVehicleService {
  public readonly regionList = [
    {
      label: ' ',
      value: null,
    },
    {
      label: '01 - R1',
      value: '01',
    },
    {
      label: '02 - R2',
      value: '02',
    },
    {
      label: '03 - R3',
      value: '03',
    },
    {
      label: '04 - R4',
      value: '04',
    },
    {
      label: '05 - R5',
      value: '05',
    },
    {
      label: '06 - R6',
      value: '06',
    },
    {
      label: '07 - Ent./Tim./Wildlife',
      value: '07',
    },
    {
      label: '08 - R8',
      value: '08',
    },
    {
      label: '09 - R9',
      value: '09',
    },
    {
      label: '10 - R10',
      value: '10',
    },
    {
      label: '12 - IITF Ops',
      value: '12',
    },
    {
      label: '13 - WO/LEI/FAM',
      value: '13',
    },
    {
      label: '22 - RMRS',
      value: '22',
    },
    {
      label: '24 - NRS',
      value: '24',
    },
    {
      label: '26 - PNWRS',
      value: '26',
    },
    {
      label: '27 - PSRS',
      value: '27',
    },
    {
      label: '33 - SRS',
      value: '33',
    },
    {
      label: '42 - S&PF',
      value: '42',
    },
  ] as const;

  public readonly regionList$ = of(this.regionList);

  constructor() {}
}
